import { PAGE_TRANSITION_MARK } from './markPageTransition';
import { getEntriesByName, measure } from './performance';

var isPerformanceSupported = function isPerformanceSupported(pageTransEntry) {
  return pageTransEntry !== undefined;
};

var wasPageTransition = function wasPageTransition(pageTransitions) {
  return pageTransitions.length > 0;
};

export var timeDifferenceBetween = function timeDifferenceBetween(startMark, endMark, measurementName, performance) {
  try {
    measure(measurementName, startMark, endMark, performance);
  } catch (err) {// do nothing
  }

  var entries = getEntriesByName(measurementName, performance) || [];
  return entries.length > 0 ? entries[0].duration : undefined;
};
export var calculateTimeElapsedSinceLastTransitionOrMarkTime = function calculateTimeElapsedSinceLastTransitionOrMarkTime(markName, performance) {
  var pageTransitionEntry = getEntriesByName(PAGE_TRANSITION_MARK, performance);

  if (!isPerformanceSupported(pageTransitionEntry)) {
    return undefined;
  }

  if (!wasPageTransition(pageTransitionEntry)) {
    var entries = getEntriesByName(markName, performance) || [];
    return entries.length > 0 ? entries[0].startTime : undefined;
  }

  var measurementName = "".concat(markName, "_measurement");
  return timeDifferenceBetween(PAGE_TRANSITION_MARK, markName, measurementName, performance);
};
//# sourceMappingURL=performanceTimeDifference.js.map